module.exports = __webpack_public_path__ + "startpage-746fed5a/template-4-preview-f0ab9a23ced3df7726bdb258cdd4071d.jpg";